import { render, staticRenderFns } from "./account_sidebar.vue?vue&type=template&id=94212608&scoped=true"
import script from "./account_sidebar.vue?vue&type=script&lang=js"
export * from "./account_sidebar.vue?vue&type=script&lang=js"
import style0 from "./account_sidebar.vue?vue&type=style&index=0&id=94212608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94212608",
  null
  
)

export default component.exports